function readProxyUrlTemplate (): string | undefined {
  return process.env.VUE_APP_PROXY_URL
}

// Environments whose frontend origin already routes every country through one
// bare domain (path-based routing) rather than a per-country subdomain — the
// window-location fallback below must not insert a country prefix for these.
const FLAT_GATEWAY_HOSTS = new Set(['staging.env.booksy.pm'])

export function resolveCountryGatewayOrigin (
  country: string,
  apiUrl?: string
): string {
  const proxyTemplate = readProxyUrlTemplate()
  if (proxyTemplate) {
    // Some shared environments (e.g. PL staging) route all countries through one
    // bare domain, so the template has no {country} placeholder to substitute.
    const resolvedProxyTemplate = proxyTemplate.includes('{country}')
      ? proxyTemplate.replace('{country}', country)
      : proxyTemplate
    return resolvedProxyTemplate.replace(/\/+$/, '')
  }

  if (apiUrl) {
    const resolvedApiUrl = apiUrl.includes('{country}')
      ? apiUrl.replace('{country}', country)
      : apiUrl
    if (/\/api\/?$/i.test(resolvedApiUrl)) {
      return resolvedApiUrl.replace(/\/api\/?$/i, '')
    }
    return resolvedApiUrl.replace(/\/+$/, '')
  }

  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location
    if (FLAT_GATEWAY_HOSTS.has(hostname)) {
      return origin.replace(/\/+$/, '')
    }
    return origin
      .replace('://', `://${country}.`)
      .replace(/\/+$/, '')
  }

  throw new Error('Cannot resolve country gateway origin')
}
